import * as React from "react";
import { ChangeEvent, ChangeEventHandler, useEffect, useState } from "react";
import API from "../Api";
import { useSession } from "../session/Context";
import { toast } from "react-toastify";

import Select, { SelectChangeEvent } from "@mui/material/Select";

export default function CreateSchema() {

  const [types, setTypes] = useState<any[]>([]);

  const [data, setData] = useState<any>({
    added_type:"",
    types: [],
    schema: "",
    srafts: [],
   
  });

  const setPartialData = (e: ChangeEvent<any>) => {
    let { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const updateType = () => {
    let newArray = [...data.types];
    newArray.push(data.added_type);

    setData({ ...data, "types": newArray });
  };


  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    let body = {
      ...data, schema: JSON.parse(data.schema)
    };

    API("/api/v1/schemas", {
      method: "POST",
      body: JSON.stringify(body),
    })
      .then((resp) => {
        toast.success(resp);
      })
      .catch((e) => toast.error(e));
  };



  return (
    <>
      <div className="mobile-pro">
        <h1>Create new schema</h1>
      </div>

      <div className="col-content">
        <div className="notifications-container">
          <div className="messages m-hide">
            <p className="light"></p>
            <h2>Create new schema</h2>
          </div>

          <form onSubmit={onSubmit} className="form">
            <div className="add_issuance__cards">
              <div className="cards">
         
                <label>Types:</label>
                <div className="list_type">
                    {data.types.length !== 0 ? <>
                        {data.types.map((item:any, index: number) => {
                            const i = index;
                            return (
                                <p key={item}>{item + " "}<button className="x_btn" type="button" onClick={() => {
                                    setData((oldData: any) => {
                                        const types = oldData.types;
                                        types.splice(i, 1)
                                        return {...oldData, types: types};
                                    })
                                }}>Remove</button></p>
                            );
                        })}
                    </>:<>
                        <li>No types.</li>
                    </>}
                    
                </div>

                <label>Add new type:</label>
                <div className="add_type_div">
                    <input required name="added_type" type="text" value={data.added_type} onChange={setPartialData} className="add_type_field template-field" ></input>
                    <button type="button" className="btn-primary add_type_btn" onClick={() => {updateType()}} >Add</button>
                </div>

                <label>Content:</label>
                <textarea required style={{height:"250px"}} className="template-field" name="schema" value={data.schema} onChange={setPartialData} ></textarea>

              </div>
            </div>

            <button className="btn btn-primary issuance__btn" type="submit" value="Add" > Add schema </button>
          </form>
        </div>
      </div>
    </>
  );
}
